import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/profile/icon_editavatar.png'


const _hoisted_1 = { class: "profile_container" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "edit" }

import CustomHeader from '../components/common/customHeader.vue';
import RowField from './components/rowField.vue';
import NameEditPopup from './components/nameEditPopup.vue';
import { ref } from 'vue';
import PasswordChangePopup from './components/passwordChangePopup.vue';
import WithdrawalInfoPopup from './components/withdrawalInfoPopup.vue';
import LogoutPopup from './components/logoutPopup.vue';
import { ProfileSettingData } from '@/view/profile/supportScript';
import WithdrawPasswordPopup from './components/withdrawPasswordPopup.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'profileView',
  props: {
    dataSet: {}
  },
  emits: ['goToPath'],
  setup(__props: any, { emit: __emit }) {

const nameEditRef = ref()
const passwordChangeRef = ref()
const withdrawInforRef = ref()
const withdrawPasswordRef = ref()
const logoutRef = ref()

const props = __props

const emits = __emit

const handleNameEdit = () => {
    nameEditRef.value.open(props.dataSet?.nickName)
}
const handlePasswordChange = () => {
    passwordChangeRef.value.open()
}
const showWithdrawInfo = () => {
    withdrawInforRef.value.open()
}
const showWithdrawPassword = () => {
    withdrawPasswordRef.value.open()
}
const showLogout = () => {
    logoutRef.value.open()
}
const goToPath = (path : string) => {
   emits('goToPath', path)
}


return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomHeader, {
      text: _ctx.$t('profile.settings'),
      isShowRightIcon: true
    }, null, 8, ["text"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_row, { class: "avatar" }, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, {
            span: "8",
            offset: "8",
            class: "avatar_img"
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: _ctx.dataSet?.avatarImg,
                alt: "",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (goToPath('/sd-avatar')))
              }, null, 8, _hoisted_2),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: "",
                  onClick: _cache[1] || (_cache[1] = () => goToPath('/sd-avatar'))
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(RowField, {
        labelText: _ctx.$t('profile.brandName'),
        isShowRightIcon: true,
        rightImage: require('@/assets/profile/wtieVolor.png'),
        bgColor: "#ffffff0a",
        content: _ctx.dataSet?.nickName,
        onOnClickRight: handleNameEdit
      }, null, 8, ["labelText", "rightImage", "content"]),
      _createVNode(RowField, {
        labelText: _ctx.$t('profile.registeredAcc'),
        content: _ctx.dataSet?.loginAccount,
        bgColor: "#ffffff0a"
      }, null, 8, ["labelText", "content"]),
      _createVNode(RowField, {
        labelText: _ctx.$t('profile.password'),
        isShowRightIcon: true,
        content: "* * * * * * * * *",
        bgColor: "#ffffff0a",
        rightImage: require('@/assets/profile/wtieVolor.png'),
        onOnClickRight: _cache[2] || (_cache[2] = ($event: any) => (handlePasswordChange()))
      }, null, 8, ["labelText", "rightImage"]),
      _createVNode(RowField, {
        isShowRightIcon: true,
        content: _ctx.$t('profile.withdrawalInfo'),
        bgColor: "#ffffff0a",
        rightImage: require('@/assets/profile/card_icon.png'),
        onOnClickRight: _cache[3] || (_cache[3] = ($event: any) => (showWithdrawInfo()))
      }, null, 8, ["content", "rightImage"]),
      _createVNode(RowField, {
        isShowRightIcon: true,
        content: _ctx.$t('profile.withdrawalPasswordSetting'),
        bgColor: "#1F0B00",
        rightImage: require('@/assets/profile/edit_icon.png'),
        onOnClickRight: _cache[4] || (_cache[4] = ($event: any) => (showWithdrawPassword()))
      }, null, 8, ["content", "rightImage"]),
      _cache[6] || (_cache[6] = _createElementVNode("div", { style: {"margin-top":"35px"} }, null, -1)),
      _createVNode(RowField, {
        isShowRightIcon: true,
        content: _ctx.$t('profile.logout'),
        bgColor: "#ffffff0a",
        onOnClickRight: _cache[5] || (_cache[5] = ($event: any) => (showLogout())),
        rightImage: require('@/assets/profile/logout_icon.png'),
        opacityNone: true
      }, null, 8, ["content", "rightImage"])
    ]),
    _createVNode(NameEditPopup, {
      ref_key: "nameEditRef",
      ref: nameEditRef
    }, null, 512),
    _createVNode(PasswordChangePopup, {
      ref_key: "passwordChangeRef",
      ref: passwordChangeRef
    }, null, 512),
    _createVNode(WithdrawalInfoPopup, {
      ref_key: "withdrawInforRef",
      ref: withdrawInforRef
    }, null, 512),
    _createVNode(WithdrawPasswordPopup, {
      ref_key: "withdrawPasswordRef",
      ref: withdrawPasswordRef
    }, null, 512),
    _createVNode(LogoutPopup, {
      ref_key: "logoutRef",
      ref: logoutRef
    }, null, 512)
  ], 64))
}
}

})